/*
 * Construction du payload de calcul des remboursements SAV.
 * Les cadeaux sélectionnés sont des articles physiquement retournés : ils doivent
 * donc être inclus dans le recalcul promotionnel, même sans choix de résolution.
 */
(function (root, factory) {
  'use strict';

  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (root) {
    root.SAVRefundItems = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function buildRefundCalculationItems(selectedItems, orderItems, resolutions) {
    const selected = selectedItems && typeof selectedItems === 'object' ? selectedItems : {};
    const order = Array.isArray(orderItems) ? orderItems : [];
    const selectedResolutions = resolutions && typeof resolutions === 'object' ? resolutions : {};
    const orderById = new Map(order.map(item => [String(item.line_item_id), item]));

    return Object.keys(selected).reduce((payload, lineItemId) => {
      const orderItem = orderById.get(String(lineItemId));
      if (!orderItem) return payload;

      const selectedItem = selected[lineItemId] || {};
      const resolutionData = selectedResolutions[lineItemId] || {};
      const resolution = orderItem.is_gift ? 'refund' : resolutionData.resolution;

      // Un article payant n'entre dans le calcul qu'après le choix de sa résolution.
      // Un cadeau sélectionné est toujours retourné physiquement et doit être inclus.
      if (!resolution) return payload;

      const parsedQuantity = Number.parseInt(selectedItem.quantity, 10);
      const quantity = Number.isInteger(parsedQuantity) && parsedQuantity > 0 ? parsedQuantity : 1;

      payload.push({
        line_item_id: String(lineItemId),
        quantity,
        reason: selectedItem.reason || 'retractation',
        resolution
      });

      return payload;
    }, []);
  }

  return Object.freeze({ buildRefundCalculationItems });
});
